import reviewRoutes from "./reviewRoutes";
import router from "@/router";

export default {
  install() {
    router.addRoute("Dashboard", reviewRoutes);
  },
};
